<template>
  <footer id="contact" :class="['site-footer', { dark }]">
    <h2 class="titles">Contact</h2>
    <p>Based in Girona, Spain. Open to Barcelona, hybrid or remote roles, and to relocation.</p>
    <p><a href="mailto:Florinlica@hotmail.com">Florinlica@hotmail.com</a></p>
    <p v-if="dark" class="republika-line">Fluorine Republika · Made in the Republika. No dark patterns allowed.</p>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    // Dark variant for the Fluorine Republika pages.
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.site-footer {
  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;
  padding: 20px 24px 40px;
  text-align: center;
  background-color: var(--gray);
  font-family: "PT Sans Narrow";
  font-size: 18px;
  color: var(--black);
}
.site-footer a {
  color: var(--dark);
}
.site-footer.dark {
  background-color: var(--fluorine-card);
  color: var(--fluorine-text);
}
.republika-line {
  margin-top: 24px;
  font-size: 14px;
  opacity: 0.7;
}
.site-footer.dark .titles,
.site-footer.dark a {
  color: var(--fluorine);
}
</style>
